import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { appAgentService } from '../../services/central-api/app-agent';
import { StyleProp, TextStyle } from 'react-native';

type SetStateCallback<S> = ((prevState: S) => S);

interface Props {
    value: number;
    setValue: React.Dispatch<SetStateCallback<number>>;
    zIndex: number;
    disabled?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

export default function AssignmentDropdown({ value, setValue, zIndex, disabled, labelStyle, viewStyle }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    async function getItems() {
        try {
            setIsLoading(true);
            const items = await appAgentService.getAssignments();
            setItems(items.map((item) => {
                return {
                    value: item.id,
                    label: item.name
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getItems();
    }, []);

    return (
        <FilterDropdown
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            label={translate('assignment')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            loading={isLoading}
            disabled={disabled}
        />
    );
}
